import _defineProperty2 from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import * as logger from 'loglevel';
import prefix from 'loglevel-plugin-prefix';
import { getConfigValue } from '@jutro/config';
var DEFAULT_LOGGER_CONFIG = {
  level: getConfigValue('JUTRO_LOGGER_LEVEL', 'WARN'),
  prefixTemplate: '%l:',
  loggerName: 'jutro-logger'
};
var Logger = function () {
  function Logger(loggerConfig) {
    _classCallCheck(this, Logger);
    _defineProperty(this, "log", void 0);
    var config = loggerConfig || DEFAULT_LOGGER_CONFIG;
    this.setConfig(config);
  }
  _createClass(Logger, [{
    key: "setConfig",
    value: function setConfig(config, replace) {
      var configs = replace ? config : _objectSpread({}, DEFAULT_LOGGER_CONFIG, {}, config);
      var level = configs.level,
        prefixTemplate = configs.prefixTemplate,
        loggerName = configs.loggerName;
      prefix.reg(logger);
      prefix.apply(logger, {
        template: prefixTemplate
      });
      this.log = logger.getLogger(loggerName);
      this.log.setLevel(level);
    }
  }, {
    key: "resetConfig",
    value: function resetConfig() {
      this.setConfig(DEFAULT_LOGGER_CONFIG);
    }
  }, {
    key: "trace",
    value: function trace(message) {
      this.log.trace(message);
    }
  }, {
    key: "debug",
    value: function debug(message) {
      this.log.debug(message);
    }
  }, {
    key: "info",
    value: function info(message) {
      this.log.info(message);
    }
  }, {
    key: "warning",
    value: function warning(message, options) {
      if (options && options.bold) {
        this.log.warn("%c".concat(message), 'font-weight: bold');
      } else {
        this.log.warn(message);
      }
    }
  }, {
    key: "error",
    value: function error(message) {
      this.log.error(message);
    }
  }]);
  return Logger;
}();
export { Logger as default };
export var log = new Logger();
export var trace = function trace(message) {
  log.trace(message);
};
export var debug = function debug(message) {
  log.debug(message);
};
export var info = function info(message) {
  log.info(message);
};
export var warning = function warning(message, options) {
  log.warning(message, options);
};
export var error = function error(message) {
  log.error(message);
};
var logOnce = function logOnce(messageFunction) {
  var called = false;
  return function (message) {
    if (!called) {
      called = true;
      messageFunction(message);
    }
  };
};
export var makeUniqueWarningLog = function makeUniqueWarningLog(message) {
  return logOnce(function () {
    return warning(message);
  });
};